import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-toggle',
  template: `
    <label class="relative cursor-pointer">
      <input
        type="checkbox"
        [checked]="checked"
        [ngModel]="checked"
        [disabled]="disabled"
        class="peer sr-only"
        (ngModelChange)="innerCheckedChange($event)" />
      <div
        class="inline-block h-7 w-12 select-none rounded-full bg-neutral-300 p-0.5 align-middle transition duration-300 ease-out after:absolute after:h-6 after:w-6 after:rounded-full after:bg-white after:drop-shadow-[2px_0_6px_rgba(12,33,44,0.10)] after:transition after:duration-300 after:ease-out after:content-[''] peer-checked:bg-primary-600 peer-checked:after:translate-x-5 peer-checked:after:drop-shadow-[-2px_0_6px_rgba(12,33,44,0.10)] peer-focus:outline-none"></div>
      <span class="prose prose-text-sm ml-3"><ng-content></ng-content></span>
    </label>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ]
})
export class ToggleComponent implements OnInit, ControlValueAccessor, OnDestroy {
  onChange: Function = () => {};
  onTouched: Function = () => {};

  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;

  @ViewChild('input', { static: true }) inputRef!: ElementRef<HTMLInputElement>;

  private destroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  writeValue(obj: any): void {
    this.checked = obj;
    this.cdr.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = this.disabled || isDisabled;
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  innerCheckedChange(checked: boolean) {
    if (!this.disabled) {
      this.checked = checked;
      this.onChange(this.checked);
    }
  }
}
